import React from 'react';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ProposalsHeader = ({ 
    selectedCount, 
    onDeleteBulk, 
    onDownloadBulk, 
    isBulkDownloading 
}) => {
    const navigate = useNavigate();
    
    return (
        <header className="proposals-header">
            <div className="header-left">
                <h1>Proposals Workspace</h1>
                <p className="subtitle">Manage proposal workflows, deadlines, and team progress efficiently.</p>
            </div>
            <div className="header-actions">
                <button className="primary-btn-indigo" onClick={() => navigate('/proposals/new')}>
                    <Plus size={16} /> New RFP
                </button>
            </div>
        </header>
    );
};

export default ProposalsHeader;
